export default __webpack_public_path__ + "static/ethics@1x-c183b931410ec2f9102135e1b6fcac7d.jpg";